"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerOrderDishUpdateSchema = exports.CustomerOrderDishUpdateScalarSchema = exports.CustomerOrderDishCreateSchema = exports.CustomerOrderDishCreateScalarSchema = exports.CustomerOrderDishPrismaUpdateSchema = exports.CustomerOrderDishPrismaCreateSchema = exports.CustomerOrderDishSchema = exports.CustomerOrderDishScalarSchema = void 0;
// @ts-nocheck
const zod_1 = require("zod");
const DishStatus_schema_1 = require("../enums/DishStatus.schema");
const baseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
    categoryName: zod_1.z.string(),
    quantity: zod_1.z.number(),
    unitEffectivePriceInCents: zod_1.z.number(),
    discount: zod_1.z.number(),
    status: DishStatus_schema_1.DishStatusSchema,
    dishIdAtOrderTime: zod_1.z.string().uuid(),
    orderIndex: zod_1.z.number(),
    createdAt: zod_1.z.coerce.date().default(() => new Date()),
    updatedAt: zod_1.z.coerce.date().default(() => new Date()),
    encodedAndCompressedDish: zod_1.z.string(),
}).strict();
const relationSchema = zod_1.z.object({
    customerOrderDishAddOns: zod_1.z.array(zod_1.z.unknown()).optional(),
    order: zod_1.z.record(zod_1.z.unknown()),
});
const fkSchema = zod_1.z.object({
    orderId: zod_1.z.string().uuid(),
});
/**
 * `CustomerOrderDish` schema excluding foreign keys and relations.
 */
exports.CustomerOrderDishScalarSchema = baseSchema;
/**
 * `CustomerOrderDish` schema including all fields (scalar, foreign key, and relations) and validations.
 */
exports.CustomerOrderDishSchema = exports.CustomerOrderDishScalarSchema.merge(fkSchema).merge(relationSchema.partial());
/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
exports.CustomerOrderDishPrismaCreateSchema = baseSchema.partial().passthrough();
/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
exports.CustomerOrderDishPrismaUpdateSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
    categoryName: zod_1.z.string(),
    quantity: zod_1.z.union([zod_1.z.number(), zod_1.z.record(zod_1.z.unknown())]),
    unitEffectivePriceInCents: zod_1.z.union([zod_1.z.number(), zod_1.z.record(zod_1.z.unknown())]),
    discount: zod_1.z.union([zod_1.z.number(), zod_1.z.record(zod_1.z.unknown())]),
    status: DishStatus_schema_1.DishStatusSchema,
    dishIdAtOrderTime: zod_1.z.string().uuid(),
    orderIndex: zod_1.z.union([zod_1.z.number(), zod_1.z.record(zod_1.z.unknown())]),
    createdAt: zod_1.z.coerce.date().default(() => new Date()),
    updatedAt: zod_1.z.coerce.date().default(() => new Date()),
    encodedAndCompressedDish: zod_1.z.string()
}).partial().passthrough();
/**
 * `CustomerOrderDish` schema for create operations excluding foreign keys and relations.
 */
exports.CustomerOrderDishCreateScalarSchema = baseSchema.partial({
    status: true, createdAt: true, updatedAt: true
});
/**
 * `CustomerOrderDish` schema for create operations including scalar fields, foreign key fields, and validations.
 */
exports.CustomerOrderDishCreateSchema = exports.CustomerOrderDishCreateScalarSchema.merge(fkSchema);
/**
 * `CustomerOrderDish` schema for update operations excluding foreign keys and relations.
 */
exports.CustomerOrderDishUpdateScalarSchema = baseSchema.partial();
/**
 * `CustomerOrderDish` schema for update operations including scalar fields, foreign key fields, and validations.
 */
exports.CustomerOrderDishUpdateSchema = exports.CustomerOrderDishUpdateScalarSchema.merge(fkSchema.partial());
